import React, { useEffect } from "react";
import { NumberRangeStyle } from "./NumberRangeStyle";
import { TextField, FormControl, Button } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";

export default function NumberRange({
  title,
  identifier,
  onSelect,
  filterButton = false,
  dateValue = null, 
  required
}) {
  const classes = NumberRangeStyle();

  const [state, setState] = React.useState({
    min: null,
    max: null
  });

  const [value, setValue] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Format the compact text shown in the main TextField
  const getDisplayValue = (selected) => {
    const { min, max } = selected || {};
    if (min == null && max == null) return "";
    if (min != null && max != null) return `${min} - ${max}`;
    if (min != null) return `≥ ${min}`;
    if (max != null) return `≤ ${max}`;
    return "";
  };

  // Sync in from prop
  useEffect(() => {
    if (dateValue && (dateValue.min != null || dateValue.max != null)) {
      setState({
        min: dateValue.min ?? null,
        max: dateValue.max ?? null
      });
      setValue(getDisplayValue(dateValue));
    } else if (!dateValue && value) {
      clear();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateValue]);

  const emitIfAuto = (nextState) => {
    if (!filterButton) {
      onSelect({ ...nextState }, identifier);
    }
  };

  const handleMinChange = (e) => {
    const raw = e.target.value;
    const nextMin = raw === "" ? null : Number(raw);
    const next = { ...state, min: Number.isNaN(nextMin) ? null : nextMin };
    setState(next);
    setValue(getDisplayValue(next));
    emitIfAuto(next);
  };

  const handleMaxChange = (e) => {
    const raw = e.target.value;
    const nextMax = raw === "" ? null : Number(raw);
    const next = { ...state, max: Number.isNaN(nextMax) ? null : nextMax };
    setState(next);
    setValue(getDisplayValue(next));
    emitIfAuto(next);
  };

  const clear = () => {
    const empty = { min: null, max: null };
    setState(empty);
    setValue("");
    onSelect(null, identifier);
  };

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const applyFilter = () => {
    onSelect(state, identifier);
    handleClose();
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <TextField
        className={classes.numberRange}
        variant="outlined"
        onClick={handleClick}
        label={title}
        value={value}
        InputLabelProps={{
          shrink: true,
          className: classes.label
        }}
        readOnly
        inputProps={{ className: classes.input }}
        onChange={() => {}}
        aria-describedby={id}
        placeholder={"Min - Max"}
        required={required}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Typography style={{ padding: 16 }}>
          <div className={classes.rangePicker}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, minWidth: 320 }}>
              <TextField
                label="Min"
                type="number"
                variant="outlined"
                value={state.min ?? ""}
                onChange={handleMinChange}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              />
              <TextField
                label="Max"
                type="number"
                variant="outlined"
                value={state.max ?? ""}
                onChange={handleMaxChange}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
              />
            </div>
          </div>

          <div className={classes.closeAndClear} style={{ marginTop: 12 }}>
            <Button className={classes.close} onClick={clear}>
              Clear
            </Button>
            {filterButton && (
              <Button className={classes.close} onClick={applyFilter}>
                Apply
              </Button>
            )}
          </div>
        </Typography>
      </Popover>
    </FormControl>
  );
}
